import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  social: null,
  email: null,
};

export const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setContactsSocial: (state, action) => {
      state.social = action.payload;
    },
    setContactsEmail: (state, action) => {
      state.email = action.payload;
    },

    resetContacts: () => initialState,
  },
});

export const {
  setContactsSocial,
  setContactsEmail,

  resetContacts,
} = contactsSlice.actions;

export default contactsSlice.reducer;
